import React from 'react'
import Homehero from '../components/home/Homehero'
import FeaturesSection from '../components/home/FeaturesSection'
import TwoImagesSection from '../components/home/TwoImagesSection'
import BestSellingProducts from '../components/home/BestSellingProducts'
import CtaSection from '../components/home/CtaSection'
import WhyInvestSection from '../components/home/WhyInvestSection'
import ShopByMatType from '../components/home/ShopByMatType'
import FaqSection from '../components/home/FaqSection'
import HomeGallerySection from '../components/home/HomeGallerySection'
import SEO from '../components/seo/SEO'

export default function Home() {
  return (
    <>
      <SEO
        title="Logo Branded Door Mats Zambia | Custom Branded Entrance Mats"
        description="Premium custom logo branded door mats in Zambia. High-definition branded mats for entrances, offices, and businesses. Fast delivery, superior quality, and reliable matting solutions across Zambia."
        keywords="door mats Zambia, branded door mats, custom logo mats, entrance mats Zambia, office mats, commercial mats, logo mats, doormats Zambia, custom mats, branded entrance mats, premium door mats, corporate mats"
        url="https://www.logobrandeddoormats.co.zm/"
        image="https://www.logobrandeddoormats.co.zm/images/sectionimages/HOMEHERO.jpeg"
      />
      <Homehero />
      <TwoImagesSection />
      <FeaturesSection />
      <BestSellingProducts />
      <CtaSection />
      <WhyInvestSection />
      <ShopByMatType />
      <HomeGallerySection />
      <FaqSection />
    </>
  )
}
